import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupService } from 'src/app/common/services/popup/popup.service';


@Component({
  selector: 'app-product-request-type-alert',
  templateUrl: './product-request-type-alert.component.html',
  styleUrls: ['./product-request-type-alert.component.scss']
})
export class ProductRequestTypeAlertComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) protected dialogData: any,
    private _popupService:PopupService
  ) { }

  closeAlert(action: string = ''){
    this._popupService.getModelInstance().close({
      result: action
    });
  }

}
